import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { List } from 'immutable';
import { ITrackingObject, ITrackingProperties } from 'i2g-ng-tracking';
import { IOverviewMetric } from '../../../../shared/components/overview-metric/overview-metric.interface';
import { TrackingScreenNamesEnum } from '../../../../tracking/tracking.data';
import { ReportExpandedViewTypesEnum } from '../../../../report-data/report-data.data';
import { ReportDataStore } from '../../../../report-data/report-data.store';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ExpandedSummary } from '../../../../report-data/models/expanded-summary.model';

@Component({
  selector: 'app-insights-metric-list',
  templateUrl: './insights-metric-list.component.html',
  styleUrls: ['./insights-metric-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsightsMetricListComponent implements OnInit {
  @Input() numberOfPlaceholderMetrics: number;
  @Input() metrics: List<IOverviewMetric>;
  @Input() showSummaryCards: boolean;
  @Input() limitedAccessMode: boolean; // detailed metrics are hidden for limited access users

  @Input() trackingObject: ITrackingObject;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() trackingAdditionalProperties: ITrackingProperties;

  defaultReports: ReportExpandedViewTypesEnum[] = [
    ReportExpandedViewTypesEnum.tax_year_monthly,
    ReportExpandedViewTypesEnum.pending_estimates,
  ];
  isReportsDataReady$: Observable<boolean>;

  reportExpandedViewTypesEnum: typeof ReportExpandedViewTypesEnum;

  constructor(private _reportsDataStore: ReportDataStore) {}

  ngOnInit() {
    /**
     * Make sure we have the data for all reports
     */
    this.isReportsDataReady$ = combineLatest(
      this.defaultReports.map((reportType: ReportExpandedViewTypesEnum) =>
        this._reportsDataStore.getExpandedSummaryDataByType(reportType)
      )
    ).pipe(map((reports: ExpandedSummary[]) => reports.every(Boolean)));
  }
}
